import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import am5themes_Responsive from "@amcharts/amcharts5/themes/Responsive";
import chartModel from "../../../models/charts/chart.model";
import 'CssFolder/chart.scss';

export default function TasksStoresPieChartComponent() {

  let chart;
  let chartId = 'piechart';
  let root;
  let series;
  let legend;

  function initChart(_data) {
    createChart();
    createSeries();
    loadData(_data);
    createLegend();
    // Animate on when appear
    series.appear(1000, 100);
  }

  function createChart() {
    root?.dispose(); // dispose any pre-existing roots
    root = am5.Root.new(chartId);

    // Formatter
    root.numberFormatter.set("numberFormat", "#,###");

    // Themes
    root.setThemes([
      am5themes_Responsive.new(root),
      am5themes_Animated.new(root)
    ]);

    chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        radius: am5.percent(80),
        layout: root.verticalLayout,
      })
    );

    // Chart title
    chart.children.unshift(
      am5.Label.new(root, {
        text: "Task Completion Status by Store",
        fontSize: 16,
        fontWeight: "500",
        textAlign: "center",
        x: am5.percent(50),
        centerX: am5.percent(50),
        paddingTop: 0,
        paddingBottom: 0
      })
    );
  }

  function createSeries() {
    series = chart.series.push(am5percent.PieSeries.new(root, {
      valueField: "count",
      categoryField: "category",
      legendLabelText: "{category}",
      legendValueText: "[fontSize: 12px;bold]{valuePercentTotal.formatNumber('0.0')}%[/]",
    }));

    series.get("colors").set("colors", [
      am5.color(0x84E0BE),
      am5.color(0xF38068),
    ]);

    series.labels.template.setAll({
      // radius: 0,
      fontSize: 10,
      textType: "circular",
      centerX: 0,
      centerY: 0,
      text: "{category}:\n[bold]{valuePercentTotal.formatNumber('0.0')}%[/] ({count})",
    });
  }

  function loadData(_data) {
    series.data.setAll(_data);
  }

  function createLegend() {
    legend = chart.children.push(am5.Legend.new(root, {
      centerX: am5.p50,
      x: am5.p50,
      layout: root.gridLayout,
    }));

    legend.labels.template.setAll({
      fontSize: 12,
      fontWeight: "300"
    });

    legend.data.setAll(series.dataItems);
  }

  return {
    oninit: function (vnode) {
      chartId += chartModel.generateID();
    },
    oncreate: function (vnode) {
      if (vnode.attrs.data) {
        initChart(vnode.attrs.data);
      }
    },
    view: function (vnode) {
      return m('.chart', {
        id: chartId,
      });
    }
  }
}
